import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center p-4 bg-black/30">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full p-6 md:p-8">
        <div className="flex items-start space-x-4">
          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-gray-100 rounded-full">
            <i className="ri-shield-check-line text-xl text-gray-700"></i>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Çerez ve Gizlilik Bildirimi
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Web sitemizde size daha iyi hizmet sunabilmek için çerezler kullanıyoruz. 
              Detaylı bilgi için{' '}
              <Link to="/kvkk" className="text-gray-900 font-medium underline cursor-pointer">
                KVKK
              </Link>
              {' '}ve{' '}
              <Link to="/cerez-politikasi" className="text-gray-900 font-medium underline cursor-pointer">
                Çerez Politikası
              </Link>
              {' '}sayfalarını inceleyebilirsiniz.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={handleAccept}
                className="px-6 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Kabul Et
              </button>
              <button
                onClick={handleReject}
                className="px-6 py-2.5 border-2 border-gray-300 hover:border-gray-400 text-gray-700 text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Reddet
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
